// extracted by mini-css-extract-plugin
module.exports = {"root":"Countdown_root__vzYrj","unavailable":"Countdown_unavailable__WUDvk","imageWrapper":"Countdown_imageWrapper__5KPvc","countdown":"Countdown_countdown__Bj2OM"};